import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuthStore from '../utils/authStore';
import { NeoCard, NeoCardContent, NeoCardHeader, NeoCardTitle } from './NeoCard'; // Assuming NeoCard is in the same folder

interface ProtectedRouteProps {
  // No specific props needed for now, but can be extended
  // e.g., roles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = () => {
  const { user, isLoading } = useAuthStore((state) => ({
    user: state.user,
    isLoading: state.isLoading,
  }));
  const location = useLocation();

  if (isLoading) {
    // Show a loading state while checking authentication status
    // This prevents a flash of the login page or the protected content
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <NeoCard className="w-full max-w-md text-center">
          <NeoCardHeader>
            <NeoCardTitle className="text-2xl">Verifying Access...</NeoCardTitle>
          </NeoCardHeader>
          <NeoCardContent>
            <p className="text-muted-foreground font-mono py-4">
              Please wait while we check your credentials for the laboratory.
            </p>
            {/* Optional: Add a spinner or more elaborate loading animation here */}
            <div className="animate-pulse font-mono text-accent">[Loading...]</div>
          </NeoCardContent>
        </NeoCard>
      </div>
    );
  }

  if (!user) {
    // User is not authenticated, redirect to login page
    // Pass the current location so that after login, user can be redirected back
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated, render the child route (the protected page)
  return <Outlet />;
};

export default ProtectedRoute;
